module.exports = __webpack_public_path__ + "img/img_jywc.d18d935f.svg";